"use client"

import DeepLinkLocationOverride from "@/components/deeplinklocation/DeepLinkLocationOverride";
import { LocationContext, locationInitializer, locationReducer } from "@/components/framework/locationswitcher/locationReducer";
import { ReactNode, useEffect, useReducer } from "react";



//#region [Props]
type LocationStateWrapperProps = {
    children: ReactNode;
};
//#endregion

//#region [Component]
export default function LocationStateWrapper({ children }: LocationStateWrapperProps) {
    const [locationState, locationDispatch] = useReducer(locationReducer, { selected: [], isShowingLocationTools: false });

    useEffect(() => {
        // workaround to prevent hydration errors
        const initState = locationInitializer({ selected: [], isShowingLocationTools: locationState.isShowingLocationTools });
        locationDispatch({ type: "replace", value: initState.selected});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <LocationContext.Provider value={{ ...locationState, dispatcher: locationDispatch }}>
        {children}
        <DeepLinkLocationOverride />
    </LocationContext.Provider>;
}
//#endregion

//#region [Styles]

//#endregion